"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkInteger = checkInteger;
exports.checkIntegerRange = checkIntegerRange;
exports.checkValidVersion = checkValidVersion;
exports.checkString = checkString;
exports.missingError = missingError;
exports.onlyErrors = onlyErrors;
exports.dateDiffInDays = void 0;

function checkInteger(integer, message) {
  return Number.isInteger(integer) ? true : message;
}

function checkIntegerRange(integer, minValue, maxValue, message) {
  return Number.isInteger(integer) && integer >= minValue && integer <= maxValue ? true : message;
}

function checkValidVersion(versionString) {
  if (!versionString || versionString.length === 0) {
    return true;
  }

  const versionPattern = /^(0|[1-9]\d*)(?:\.(0|[1-9]\d*))?(?:\.(0|[1-9]\d*))?$/;
  return versionPattern.test(versionString);
}

function checkString(string, message, minLength = 1) {
  const answer = string && string.length !== undefined && string.length >= minLength ? true : message;
  return answer;
}

function missingError(fieldName) {
  return `Missing field ${fieldName}`;
}

function onlyErrors(errorMessage) {
  return Object.values(errorMessage).filter(value => value !== true);
}

const _MS_PER_DAY = 1000 * 60 * 60 * 24; // a and b are javascript Date objects


const dateDiffInDays = (a, b) => {
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
};

exports.dateDiffInDays = dateDiffInDays;